import { Avatar, AvatarFallback } from '@neo/primitives/avatar'
import parsePhoneNumberFromString from 'libphonenumber-js'
import type { RInternalNumber } from 'v2/types/api/settings'
import { TransferButtons } from './transfer-buttons'

interface InternalContactItemProps {
  contact: RInternalNumber
  onTransfer: (type: 'warm' | 'cold') => void
  isDisabled: boolean
}

export const InternalContactItem = ({
  contact,
  onTransfer,
  isDisabled,
}: InternalContactItemProps) => {
  const validNumber = contact.phone_number?.split?.('#')?.[0]
  const phoneNumber = parsePhoneNumberFromString(validNumber, 'US')
  const extensionPhone = parsePhoneNumberFromString(contact.phone_number, 'US')
  const initials = contact.first_name?.[0]?.toUpperCase() || '#'

  return (
    <div className="flex items-center p-2 px-1 overflow-hidden gap-2 group cursor-default hover:bg-accent rounded-md border-b border-b-st2 last:border-b-0">
      <Avatar className="h-7 w-7 text-s-400">
        <AvatarFallback className="bg-hv1 text-secondary">{initials}</AvatarFallback>
      </Avatar>
      <div className="overflow-hidden flex-1">
        <div className="text-p-400 flex items-center gap-2">
          <div className="truncate">{contact.first_name || phoneNumber?.formatInternational()}</div>
        </div>
        <div className="text-s-400 text-tertiary truncate">
          {phoneNumber?.formatInternational()}
          {extensionPhone?.ext ? `#${extensionPhone.ext}` : ''}
        </div>
      </div>
      <TransferButtons onTransfer={onTransfer} isDisabled={isDisabled} prefix="internal-" />
    </div>
  )
}
